import { number, object } from 'yup';

import { validationErrMessages } from '@constants/validationConstants';

export const validationSchema = object({
	rentalPeriodFrom: number()
		.required(validationErrMessages.rentalPeriodFrom),
	rentalPeriodTo: number()
		.required(validationErrMessages.rentalPeriodTo),
});
